import {Fonts} from "@/constants/font";
import BBCodeText from "phaser3-rex-plugins/plugins/bbcodetext";
import {Keys} from "@/constants/key";
import {ForumDto, ForumFilter, ForumTab, Tag} from "@/store/forum/types";
import {ForumUtils} from "@/utils/forum-utils";
import {RadioPanel} from "@/scenes.ui/radio-panel";
import BaseSound = Phaser.Sound.BaseSound;
import TextUtils from "@/utils/text-utils";
import {Checkbox} from "@/scenes.ui/checkbox";
import {Tr} from "@/i18n/i18n";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "../utils/c-u";

export class FilterPanel extends Phaser.GameObjects.Container {

    private selectSound: BaseSound | undefined;

    private selectedTab!: ForumTab;
    private selectedFilter!: ForumFilter;
    private selectedTags!: Tag[];

    constructor(scene: Phaser.Scene, canvas: HTMLCanvasElement, selectSound: BaseSound | undefined,
                f: ForumDto, closeCallback: (tab: ForumTab, selectedTags: Tag[], filter: ForumFilter) => unknown) {
        super(scene);

        this.scene = scene;
        this.height = 300 * CU.S + f.availableTags.length * 15 * CU.S;
        this.x = canvas.width / 2;
        this.y = 0;
        this.depth = 6000;
        this.selectSound = selectSound;
        this.selectedTags = f.selectedTags;
        this.selectedTab = f.tab;
        this.selectedFilter = f.filter;
        let self = this;

        let background = SpriteUtils.addSprite(this.scene, 0, 0, Keys.ATLAS_UI, Keys.UI_BLACK).setOrigin(0.5, 0);
        SpriteUtils.setDispSize(background, canvas!.width * 2, canvas!.height * 2);

        background.setInteractive().on('pointerup', () => {
            closeCallback(self.selectedTab, self.selectedTags, self.selectedFilter);
        });

        this.add(background);

        let yShift = 117;
        const backZero = SpriteUtils.addImage(this.scene, 0, yShift - 50, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_PANEL_BACK).setOrigin(0.5, 0);
        SpriteUtils.setDispSize(backZero, CU.CANVAS_WIDTH, this.height + 50);
        const back = SpriteUtils.addImage(this.scene, 0, yShift, Keys.ATLAS_PROFILE, Keys.UI_SCENARIO_TASK_BACK).setOrigin(0.5, 0);
        SpriteUtils.setDispSize(back, CU.CANVAS_WIDTH, this.height);
        const separatorTop = SpriteUtils.addSprite(this.scene!, 0, yShift, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR_LARGE).setOrigin(0.5, 0.5);
        const separator = SpriteUtils.addSprite(this.scene!, 0, yShift + this.height / CU.S, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR_LARGE).setOrigin(0.5, 0.5);

        let link = new BBCodeText(scene, 0, yShift * CU.S - 25 * CU.S, '[color=#C4C4C4][u]' + Tr('srch.sett') + '[/u][/color]', {
            fontFamily: Fonts.MYRIADPRO_REGULAR,
            fontSize: '13pt',
            align: 'center',
            wrap: {
                mode: 1,
                width: 420
            },
            underline: {
                color: '#C4C4C4',
                thickness: 2,
                offset: 2
            }
        }).setScale(CU.S, CU.S);

        link.setOrigin(0.5);
        back.setInteractive().on('pointerup', () => {

        });

        this.add([backZero, back, link, separatorTop, separator]);

        let yy = 180;

        let tabs = [ForumTab.TOP, ForumTab.NEW];
        let rp = new RadioPanel(scene, 0, yy, selectSound, tabs, [Tr('by.rate'), Tr('by.new')], tabs.indexOf(f.tab), (tt: any) => {
            self.selectedTab = tt;
        });
        this.add(rp);

        const tabTitle = TextUtils.addTextByFamily(this.scene, Tr('sort'), 0, yy - 40, '#c6c6c6', 12,
            'normal', 420, Fonts.ARIAL_MT)
            .setOrigin(0.5, 0.5);
        const sep1 = SpriteUtils.addSprite(this.scene!, 0, yy - 20, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR, 0.3).setOrigin(0.5, 1);
        const sep2 = SpriteUtils.addSprite(this.scene!, 0, yy + 30, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR, 0.8).setOrigin(0.5, 1);
        this.add([tabTitle, sep1, sep2]);

        yy += 90;

        const tagTitle = TextUtils.addTextByFamily(this.scene, Tr('tags'), 0, yy - 40, '#c6c6c6', 12,
            'normal', 420, Fonts.ARIAL_MT)
            .setOrigin(0.5, 0.5);
        const sep3 = SpriteUtils.addSprite(this.scene!, 0, yy - 20, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR, 0.3 / CU.S).setOrigin(0.5, 1);

        let cc = 0;
        for (let tag of f.availableTags) {
            let t = tag;
            let box: Checkbox = new Checkbox(scene, cc % 2 === 0 ? -150 : 80, yy, this.selectSound, ForumUtils.getTagName(tag),
                f.selectedTags.includes(tag), (checked: boolean) => {
                if (checked && !this.selectedTags.includes(t)) {
                    this.selectedTags.push(t);
                } else if (!checked && this.selectedTags.includes(t)) {
                    this.selectedTags = this.selectedTags.filter(tt => tt !== t);
                }
            });
            if (cc % 2 === 1) {
                yy += 35;
            }
            this.add(box);
            ++cc;
        }
        const sep4 = SpriteUtils.addSprite(this.scene!, 0, yy + 35, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR, 0.8).setOrigin(0.5, 1);
        this.add([tagTitle, sep3, sep4]);

        yy += 100;

        const filtsTitle = TextUtils.addTextByFamily(this.scene, Tr('filts'), 0, yy - 45, '#c6c6c6', 12,
            'normal', 420, Fonts.ARIAL_MT)
            .setOrigin(0.5, 0.5);
        const sep5 = SpriteUtils.addSprite(this.scene!, 0, yy - 25, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR, 0.3).setOrigin(0.5, 1);

        let filts = [ForumFilter.ALL_TIME, ForumFilter.WEEK, ForumFilter.DAY];
        rp = new RadioPanel(scene, 0, yy, selectSound, filts, [Tr('by.all.time'), Tr('by.week'), Tr('by.day')], filts.indexOf(f.filter), (tf: any) => {
            self.selectedFilter = tf;
        });
        this.add(rp);

        this.add([filtsTitle, sep5]);
    }

}
